module.exports = __webpack_public_path__ + "static/expire.0ff97505.png";